export default "__VITE_ASSET__HFIR8nZd__"